import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

export const QueueButton = ({ onClick, classColor }) => {
  return (
    <FontAwesomeIcon
      size="sm"
      icon={faSyncAlt}
      onClick={onClick}
      style={{
        cursor: 'pointer',
        opacity: 0.9,
        padding: '2px',
        borderRadius: '50%',
        background:
          classColor === 'kpiDanger' || classColor === 'kpiSafe'
            ? 'rgba(255,255,255,0.2)'
            : 'transparent',
        color:
          classColor === 'kpiDanger'
            ? '#fff'
            : classColor === 'kpiWarning'
            ? '#212529'
            : classColor === 'kpiSafe'
            ? '#fff'
            : '#495057',
        transition: 'all 0.2s ease'
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'rotate(90deg) scale(1.1)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'rotate(0deg) scale(1)';
      }}
    />
  );
};
QueueButton.propTypes = {
  onClick: PropTypes.func,
  classColor: PropTypes.string,
};

